import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Common.css';
import { apiService } from '../api/api';
import { Check } from 'lucide-react';

// ─── International Phone Validation ──────────────────────────────────────────
const COUNTRY_PHONE_RULES = [
  { code: '+1',   iso: 'US', name: 'USA / Canada',    maxLen: 12, pattern: /^\+1[2-9]\d{2}[2-9]\d{6}$/,            digits: '10 digits after +1',   example: '+12025551234' },
  { code: '+91',  iso: 'IN', name: 'India',            maxLen: 13, pattern: /^\+91[6-9]\d{9}$/,                     digits: '10 digits after +91',  example: '+919876543210' },
  { code: '+86',  iso: 'CN', name: 'China',            maxLen: 14, pattern: /^\+86(13|14|15|16|17|18|19)\d{9}$/,    digits: '11 digits after +86',  example: '+8613812345678' },
  { code: '+81',  iso: 'JP', name: 'Japan',            maxLen: 13, pattern: /^\+81[789]0\d{8}$/,                    digits: '10-11 digits after +81', example: '+819012345678' },
  { code: '+82',  iso: 'KR', name: 'South Korea',      maxLen: 13, pattern: /^\+821[0-9]\d{7,8}$/,                  digits: '9-10 digits after +82', example: '+821012345678' },
  { code: '+65',  iso: 'SG', name: 'Singapore',        maxLen: 11, pattern: /^\+65[689]\d{7}$/,                     digits: '8 digits after +65',   example: '+6591234567' },
  { code: '+60',  iso: 'MY', name: 'Malaysia',         maxLen: 13, pattern: /^\+601[0-9]\d{7,8}$/,                  digits: '9-10 digits after +60', example: '+60123456789' },
  { code: '+66',  iso: 'TH', name: 'Thailand',         maxLen: 12, pattern: /^\+66[689]\d{8}$/,                     digits: '9 digits after +66',   example: '+66812345678' },
  { code: '+63',  iso: 'PH', name: 'Philippines',      maxLen: 13, pattern: /^\+639\d{9}$/,                         digits: '10 digits after +63',  example: '+639171234567' },
  { code: '+62',  iso: 'ID', name: 'Indonesia',        maxLen: 15, pattern: /^\+628\d{8,11}$/,                      digits: '9-12 digits after +62', example: '+62812345678' },
  { code: '+92',  iso: 'PK', name: 'Pakistan',         maxLen: 13, pattern: /^\+923\d{9}$/,                         digits: '10 digits after +92',  example: '+923001234567' },
  { code: '+880', iso: 'BD', name: 'Bangladesh',       maxLen: 14, pattern: /^\+8801[3-9]\d{8}$/,                   digits: '10 digits after +880', example: '+8801712345678' },
  { code: '+971', iso: 'AE', name: 'UAE',              maxLen: 13, pattern: /^\+9715\d{8}$/,                        digits: '9 digits after +971',  example: '+971501234567' },
  { code: '+966', iso: 'SA', name: 'Saudi Arabia',     maxLen: 13, pattern: /^\+9665\d{8}$/,                        digits: '9 digits after +966',  example: '+966512345678' },
  { code: '+974', iso: 'QA', name: 'Qatar',            maxLen: 12, pattern: /^\+974[3-7]\d{7}$/,                    digits: '8 digits after +974',  example: '+97430123456' },
  { code: '+973', iso: 'BH', name: 'Bahrain',          maxLen: 12, pattern: /^\+973[3-9]\d{7}$/,                    digits: '8 digits after +973',  example: '+97333123456' },
  { code: '+968', iso: 'OM', name: 'Oman',             maxLen: 12, pattern: /^\+9689\d{7}$/,                        digits: '8 digits after +968',  example: '+96891234567' },
  { code: '+972', iso: 'IL', name: 'Israel',           maxLen: 13, pattern: /^\+9725\d{8}$/,                        digits: '9 digits after +972',  example: '+972501234567' },
  { code: '+44',  iso: 'GB', name: 'UK',               maxLen: 13, pattern: /^\+447\d{9}$/,                         digits: '10 digits after +44',  example: '+447911123456' },
  { code: '+49',  iso: 'DE', name: 'Germany',          maxLen: 15, pattern: /^\+491[567]\d{8,10}$/,                 digits: '10-12 digits after +49', example: '+4915123456789' },
  { code: '+33',  iso: 'FR', name: 'France',           maxLen: 12, pattern: /^\+33[67]\d{8}$/,                      digits: '9 digits after +33',   example: '+33612345678' },
  { code: '+39',  iso: 'IT', name: 'Italy',            maxLen: 13, pattern: /^\+393\d{9}$/,                         digits: '10 digits after +39',  example: '+393123456789' },
  { code: '+34',  iso: 'ES', name: 'Spain',            maxLen: 12, pattern: /^\+346\d{8}$/,                         digits: '9 digits after +34',   example: '+34612345678' },
  { code: '+31',  iso: 'NL', name: 'Netherlands',      maxLen: 12, pattern: /^\+316\d{8}$/,                         digits: '9 digits after +31',   example: '+31612345678' },
  { code: '+41',  iso: 'CH', name: 'Switzerland',      maxLen: 12, pattern: /^\+417[6-9]\d{7}$/,                    digits: '9 digits after +41',   example: '+41761234567' },
  { code: '+43',  iso: 'AT', name: 'Austria',          maxLen: 14, pattern: /^\+436\d{8,10}$/,                      digits: '9-11 digits after +43', example: '+436641234567' },
  { code: '+32',  iso: 'BE', name: 'Belgium',          maxLen: 12, pattern: /^\+324\d{8}$/,                         digits: '9 digits after +32',   example: '+32412345678' },
  { code: '+47',  iso: 'NO', name: 'Norway',           maxLen: 11, pattern: /^\+474\d{7}$/,                         digits: '8 digits after +47',   example: '+4741234567' },
  { code: '+46',  iso: 'SE', name: 'Sweden',           maxLen: 12, pattern: /^\+467\d{8}$/,                         digits: '9 digits after +46',   example: '+46701234567' },
  { code: '+45',  iso: 'DK', name: 'Denmark',          maxLen: 11, pattern: /^\+454\d{7}$/,                         digits: '8 digits after +45',   example: '+4541234567' },
  { code: '+358', iso: 'FI', name: 'Finland',          maxLen: 14, pattern: /^\+3584\d{7,8}$/,                      digits: '8-9 digits after +358', example: '+358412345678' },
  { code: '+48',  iso: 'PL', name: 'Poland',           maxLen: 12, pattern: /^\+48[4-9]\d{8}$/,                     digits: '9 digits after +48',   example: '+48512345678' },
  { code: '+7',   iso: 'RU', name: 'Russia',           maxLen: 12, pattern: /^\+7[789]\d{9}$/,                      digits: '10 digits after +7',   example: '+79161234567' },
  { code: '+380', iso: 'UA', name: 'Ukraine',          maxLen: 13, pattern: /^\+380[3-9]\d{8}$/,                    digits: '9 digits after +380',  example: '+380501234567' },
  { code: '+30',  iso: 'GR', name: 'Greece',           maxLen: 13, pattern: /^\+306\d{9}$/,                         digits: '10 digits after +30',  example: '+306901234567' },
  { code: '+351', iso: 'PT', name: 'Portugal',         maxLen: 13, pattern: /^\+3519\d{8}$/,                        digits: '9 digits after +351',  example: '+351912345678' },
  { code: '+36',  iso: 'HU', name: 'Hungary',          maxLen: 13, pattern: /^\+36[237]\d{7,8}$/,                   digits: '8-9 digits after +36', example: '+36201234567' },
  { code: '+420', iso: 'CZ', name: 'Czech Republic',   maxLen: 13, pattern: /^\+420[6-7]\d{8}$/,                    digits: '9 digits after +420',  example: '+420601234567' },
  { code: '+40',  iso: 'RO', name: 'Romania',          maxLen: 12, pattern: /^\+407\d{8}$/,                         digits: '9 digits after +40',   example: '+40712345678' },
  { code: '+55',  iso: 'BR', name: 'Brazil',           maxLen: 14, pattern: /^\+55[1-9][1-9]\d{8,9}$/,              digits: '10-11 digits after +55', example: '+5511912345678' },
  { code: '+52',  iso: 'MX', name: 'Mexico',           maxLen: 14, pattern: /^\+521\d{10}$/,                        digits: '10 digits after +52',  example: '+5215512345678' },
  { code: '+54',  iso: 'AR', name: 'Argentina',        maxLen: 14, pattern: /^\+549\d{10}$/,                        digits: '10 digits after +54',  example: '+5491112345678' },
  { code: '+56',  iso: 'CL', name: 'Chile',            maxLen: 12, pattern: /^\+569\d{8}$/,                         digits: '9 digits after +56',   example: '+56912345678' },
  { code: '+57',  iso: 'CO', name: 'Colombia',         maxLen: 13, pattern: /^\+573\d{9}$/,                         digits: '10 digits after +57',  example: '+573001234567' },
  { code: '+27',  iso: 'ZA', name: 'South Africa',     maxLen: 12, pattern: /^\+276\d{8}$/,                         digits: '9 digits after +27',   example: '+27612345678' },
  { code: '+234', iso: 'NG', name: 'Nigeria',          maxLen: 14, pattern: /^\+2347\d{9}$/,                        digits: '10 digits after +234', example: '+2347012345678' },
  { code: '+20',  iso: 'EG', name: 'Egypt',            maxLen: 13, pattern: /^\+201[0125]\d{8}$/,                   digits: '10 digits after +20',  example: '+201012345678' },
  { code: '+254', iso: 'KE', name: 'Kenya',            maxLen: 13, pattern: /^\+2547\d{8}$/,                        digits: '9 digits after +254',  example: '+254712345678' },
  { code: '+61',  iso: 'AU', name: 'Australia',        maxLen: 12, pattern: /^\+614\d{8}$/,                         digits: '9 digits after +61',   example: '+61412345678' },
  { code: '+64',  iso: 'NZ', name: 'New Zealand',      maxLen: 13, pattern: /^\+642\d{7,9}$/,                       digits: '8-10 digits after +64', example: '+6421234567' },
];

const detectCountryRule = (phone) => {
  if (!phone || !phone.startsWith('+')) return null;
  const sorted = [...COUNTRY_PHONE_RULES].sort((a, b) => b.code.length - a.code.length);
  return sorted.find(r => phone.startsWith(r.code)) || null;
};

const validatePhoneNumber = (phone) => {
  if (!phone || !phone.trim()) return { valid: false, message: 'Phone number is required' };
  const cleaned = phone.replace(/[\s\-().]/g, '');
  if (!cleaned.startsWith('+')) {
    return { valid: false, message: 'Phone must start with a country code (e.g. +1 for USA, +91 for India)' };
  }
  const rule = detectCountryRule(cleaned);
  if (!rule) {
    const genericPattern = /^\+\d{1,4}\d{6,12}$/;
    if (!genericPattern.test(cleaned)) {
      return { valid: false, message: 'Invalid phone number. Use format: +[country code][number] (e.g. +12025551234)' };
    }
    return { valid: true, message: '', country: null };
  }
  if (!rule.pattern.test(cleaned)) {
    return { valid: false, message: `Invalid ${rule.name} number. Format: ${rule.digits} (e.g. ${rule.example})`, country: rule };
  }
  return { valid: true, message: '', country: rule };
};

const SmartPhoneInput = ({
  value = '',
  onChange,
  onBlur,
  error,
  disabled = false,
  name = 'phoneNumber',
  placeholder,
  inputStyle = {},
}) => {
  const cleaned = value.replace(/[\s\-().]/g, '');
  const detected = detectCountryRule(cleaned);

  const digitsTyped = cleaned.replace(/^\+/, '').replace(/\D/g, '').length;
  const maxCleanLen = detected ? detected.maxLen : null;
  const maxDigits = maxCleanLen ? maxCleanLen - 1 : null;
  const isAtMax = maxDigits !== null && digitsTyped >= maxDigits;
  const isOverMax = maxDigits !== null && digitsTyped > maxDigits;
  const isValidNow = detected && validatePhoneNumber(value).valid;

  const borderColor = error
    ? '#ea4335'
    : isOverMax
      ? '#ea4335'
      : isValidNow
        ? '#16a34a'
        : '#e0e0e0';

  const ALLOWED = /^[+\d\s\-().]*$/;

  const emit = (newVal) => {
    if (typeof onChange === 'function') {
      onChange({ target: { name, value: newVal } });
    }
  };

  const handleKeyDown = (e) => {
    if (
      ['Backspace', 'Delete', 'Tab', 'Enter',
        'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
        'Home', 'End'].includes(e.key) || e.ctrlKey || e.metaKey
    ) return;
    if (e.key === '+') {
      if (e.target.selectionStart !== 0 || value.includes('+')) {
        e.preventDefault(); return;
      }
    }
    if (!/[\d\s\-().]/.test(e.key) && e.key !== '+') {
      e.preventDefault(); return;
    }
    if (/\d/.test(e.key) && maxDigits !== null) {
      const selectedDigits = value
        .slice(e.target.selectionStart, e.target.selectionEnd)
        .replace(/\D/g, '').length;
      const netNewDigits = 1 - selectedDigits;
      if (digitsTyped + netNewDigits > maxDigits) {
        e.preventDefault(); return;
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    let pasted = e.clipboardData.getData('text').replace(/[^+\d\s\-().]/g, '');
    const hasPlus = pasted.includes('+');
    pasted = pasted.replace(/\+/g, '');
    if (hasPlus) pasted = '+' + pasted;
    const { selectionStart: s, selectionEnd: en } = e.target;
    let newVal = value.slice(0, s) + pasted + value.slice(en);
    const newCleaned = newVal.replace(/[\s\-().]/g, '');
    const rule = detectCountryRule(newCleaned);
    if (rule) newVal = newCleaned.slice(0, rule.maxLen);
    emit(newVal);
  };

  const handleChange = (e) => {
    let val = e.target.value;
    if (!ALLOWED.test(val)) val = val.replace(/[^+\d\s\-().]/g, '');
    if (val.indexOf('+') > 0 || (val.split('+').length - 1) > 1) {
      val = '+' + val.replace(/\+/g, '');
    }
    const valCleaned = val.replace(/[\s\-().]/g, '');
    const rule = detectCountryRule(valCleaned);
    if (rule && valCleaned.length > rule.maxLen) {
      val = valCleaned.slice(0, rule.maxLen);
    }
    emit(val);
  };

  const counterText = maxDigits !== null ? `${digitsTyped} / ${maxDigits}` : null;
  const counterColor = isOverMax ? '#ea4335' : isAtMax && isValidNow ? '#16a34a' : '#9ca3af';

  return (
    <div>
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {detected && (
          <div style={{
            position: 'absolute', left: 0, top: 0, bottom: 0,
            display: 'flex', alignItems: 'center', gap: 4,
            padding: '0 10px',
            background: '#f1f5f9',
            borderTopLeftRadius: '7px', borderBottomLeftRadius: '7px',
            borderRight: `1.5px solid ${borderColor}`,
            pointerEvents: 'none', zIndex: 2, whiteSpace: 'nowrap',
            minWidth: 58,
          }}>
            <span style={{ fontSize: 16, lineHeight: 1 }}>{detected.flag}</span>
            <span style={{ fontSize: 12, fontWeight: 700, color: '#475569', letterSpacing: '0.5px' }}>
              {detected.iso}
            </span>
          </div>
        )}

        <input
          type="tel"
          name={name}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder || '+1 202 555 1234  ·  +91 98765 43210'}
          style={{
            width: '100%',
            padding: `9px ${counterText ? '60px' : '12px'} 9px ${detected ? '70px' : '12px'}`,
            borderRadius: '7px',
            border: `1.5px solid ${borderColor}`,
            fontSize: '13.5px',
            outline: 'none',
            boxSizing: 'border-box',
            transition: 'border-color 0.2s',
            backgroundColor: disabled ? '#f8f9fa' : '#fff',
            color: disabled ? '#666' : '#1e293b',
            cursor: disabled ? 'not-allowed' : 'text',
            fontFamily: 'inherit',
            ...inputStyle,
          }}
          onFocus={e => { if (!disabled) e.target.style.borderColor = error ? '#ea4335' : '#009688'; }}
        />

        {counterText && !disabled && (
          <span style={{
            position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
            fontSize: 11, fontWeight: 700, color: counterColor,
            pointerEvents: 'none', userSelect: 'none',
          }}>
            {counterText}
          </span>
        )}
      </div>

      {!disabled && (() => {
        if (detected && isValidNow && !error)
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 4, fontSize: 11, color: '#16a34a', fontWeight: 600 }}>
              <Check size={11} /> {detected.flag} {detected.name} · Valid number
            </div>
          );
        if (detected && isOverMax)
          return (
            <div style={{ marginTop: 4, fontSize: 11, color: '#ea4335', fontWeight: 600 }}>
              ⚠️ Too many digits for {detected.name} ({detected.digits})
            </div>
          );
        if (detected && !isValidNow && !error && value.length > detected.code.length)
          return (
            <div style={{ marginTop: 4, fontSize: 11, color: '#6b7280' }}>
              {detected.flag} {detected.name} · {detected.digits} · e.g. {detected.example}
            </div>
          );
        if (!detected && value && value.startsWith('+') && !error)
          return (
            <div style={{ marginTop: 4, fontSize: 11, color: '#6b7280' }}>
              🌍 Examples: +12025551234 (USA) · +919876543210 (India) · +447911123456 (UK)
            </div>
          );
        if (!value)
          return (
            <div style={{ marginTop: 4, fontSize: 11, color: '#9ca3af' }}>
              Start with country code · +1 (USA) · +91 (India) · +44 (UK)
            </div>
          );
        return null;
      })()}
    </div>
  );
};

/* ═══════════════════════════════ STYLES ═══════════════════════════════ */
const styles = `
  @keyframes fadeUp  { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
  @keyframes spin    { to{transform:rotate(360deg)} }
  @keyframes modalIn { from{opacity:0;transform:scale(0.95)} to{opacity:1;transform:scale(1)} }
  @keyframes taxSlide{ from{opacity:0;transform:translateY(-4px)} to{opacity:1;transform:translateY(0)} }

  .co-page { background:#f0f4f8; min-height:100vh; }

  .co-card {
    background:#fff; border-radius:12px; border:1px solid #e2e8e7;
    margin-bottom:14px; overflow:hidden; box-shadow:0 1px 3px rgba(0,0,0,0.06);
  }
  .co-card-head {
    padding:14px 20px; display:flex; align-items:center; gap:10px;
    border-bottom:1px solid #f0f4f3;
  }
  .step-badge {
    width:24px; height:24px; border-radius:50%; background:#009688; color:#fff;
    font-size:11px; font-weight:800; flex-shrink:0; transition:background 0.2s;
    display:flex; align-items:center; justify-content:center;
  }
  .step-badge.done { background:#2e7d32; }
  .co-card-title { font-size:14px; font-weight:700; color:#1a2e2c; flex:1; }
  .co-card-body  { padding:16px 20px; }

  /* Order items */
  .oi-row { display:flex; align-items:center; gap:12px; padding:12px 0; border-bottom:1px solid #f5f7f6; }
  .oi-row:last-child { border-bottom:none; }
  .oi-img      { width:52px; height:52px; border-radius:9px; object-fit:cover; border:1px solid #e2e8e7; flex-shrink:0; }
  .oi-fallback { width:52px; height:52px; border-radius:9px; background:#E0F2F1; border:1px solid #B2DFDB; display:flex; align-items:center; justify-content:center; font-size:20px; flex-shrink:0; }
  .oi-name  { font-size:13.5px; font-weight:600; color:#1a2e2c; line-height:1.3; }
  .oi-qty   { font-size:12px; color:#90a4ae; margin-top:3px; }
  .oi-price { font-size:14px; font-weight:700; color:#00796B; margin-left:auto; white-space:nowrap; }
  .oi-na    { font-size:12px; color:#aaa; margin-left:auto; }
  .oi-oos   { font-size:11px; font-weight:700; color:#c62828; background:#ffebee; padding:3px 9px; border-radius:20px; margin-left:auto; white-space:nowrap; }

  /* ── Tax badge on order item ── */
  .tax-badge {
    display:inline-flex; align-items:center; gap:3px;
    background:#fff8e1; color:#e65100; border:1px solid #ffe082;
    font-size:10px; font-weight:700; padding:2px 7px; border-radius:20px;
    margin-left:6px; white-space:nowrap; letter-spacing:.02em;
  }
  .tax-badge-exempt {
    display:inline-flex; align-items:center; gap:3px;
    background:#f1f8e9; color:#558b2f; border:1px solid #c5e1a5;
    font-size:10px; font-weight:700; padding:2px 7px; border-radius:20px;
    margin-left:6px; white-space:nowrap; letter-spacing:.02em;
  }

  /* Address list */
  .addr-list { display:flex; flex-direction:column; gap:8px; }
  .addr-row  { display:flex; align-items:flex-start; gap:12px; padding:12px 14px; border:1.5px solid #e2e8e7; border-radius:10px; cursor:pointer; transition:all 0.15s; background:#fff; position:relative; }
  .addr-row:hover    { border-color:#80cbc4; background:#fafffe; }
  .addr-row.selected { border-color:#009688; background:#e8f5f4; }
  .addr-radio { width:17px; height:17px; border-radius:50%; border:2px solid #cfd8dc; flex-shrink:0; margin-top:2px; display:flex; align-items:center; justify-content:center; transition:border-color 0.15s; }
  .addr-row.selected .addr-radio { border-color:#009688; }
  .addr-radio-dot { width:8px; height:8px; border-radius:50%; background:#009688; transform:scale(0); transition:transform 0.18s cubic-bezier(0.34,1.56,0.64,1); }
  .addr-row.selected .addr-radio-dot { transform:scale(1); }
  .addr-info     { flex:1; min-width:0; }
  .addr-name-row { display:flex; align-items:center; gap:7px; flex-wrap:wrap; margin-bottom:3px; }
  .addr-fullname { font-size:13.5px; font-weight:700; color:#1a2e2c; }
  .addr-phone    { font-size:12px; color:#78909c; }
  .addr-line     { font-size:12.5px; color:#607d8b; line-height:1.5; }
  .addr-email    { font-size:11.5px; color:#90a4ae; margin-top:2px; }
  .addr-badge    { font-size:10px; font-weight:700; padding:2px 7px; border-radius:4px; text-transform:uppercase; letter-spacing:.04em; }
  .badge-default  { background:#e8f5e9; color:#2e7d32; }
  .badge-billing  { background:#e3f2fd; color:#1565c0; }
  .badge-shipping { background:#f3e5f5; color:#6a1b9a; }

  .addr-delete-btn {
    background:none; border:none; cursor:pointer; color:#ef5350;
    font-size:15px; padding:4px 7px; border-radius:6px; line-height:1;
    flex-shrink:0; align-self:center; transition:background 0.15s;
    display:flex; align-items:center; justify-content:center;
  }
  .addr-delete-btn:hover { background:#ffebee; }

  .confirm-overlay {
    position:fixed; inset:0; background:rgba(0,0,0,0.45);
    display:flex; align-items:center; justify-content:center; z-index:9999;
    animation:fadeUp 0.15s ease;
  }
  .confirm-modal {
    background:#fff; border-radius:14px; padding:28px;
    max-width:380px; width:90%; box-shadow:0 12px 40px rgba(0,0,0,0.2);
    animation:modalIn 0.18s ease;
  }
  .confirm-modal-icon  { font-size:28px; margin-bottom:10px; }
  .confirm-modal-title { font-size:15px; font-weight:700; color:#1a2e2c; margin-bottom:6px; }
  .confirm-modal-msg   { font-size:13px; color:#607d8b; line-height:1.55; margin-bottom:22px; }
  .confirm-modal-btns  { display:flex; gap:10px; }
  .btn-confirm-cancel {
    flex:1; padding:10px 0; background:#fff; color:#78909c;
    border:1.5px solid #dde4e3; border-radius:8px; font-size:13px;
    font-weight:600; cursor:pointer; transition:all .15s;
  }
  .btn-confirm-cancel:hover { border-color:#90a4ae; background:#f8f9fa; }
  .btn-confirm-delete {
    flex:1; padding:10px 0; background:#c62828; color:#fff;
    border:none; border-radius:8px; font-size:13px;
    font-weight:700; cursor:pointer; transition:background .15s;
    display:flex; align-items:center; justify-content:center; gap:6px;
  }
  .btn-confirm-delete:hover:not(:disabled) { background:#b71c1c; }
  .btn-confirm-delete:disabled { opacity:.55; cursor:not-allowed; }

  .addr-add-row { display:flex; align-items:center; gap:10px; padding:12px 14px; border:1.5px dashed #b2dfdb; border-radius:10px; cursor:pointer; color:#009688; font-size:13.5px; font-weight:500; transition:all 0.15s; }
  .addr-add-row:hover { border-color:#009688; background:#e8f5f4; }
  .addr-add-icon { width:28px; height:28px; border-radius:7px; background:#e0f2f1; border:1px solid #b2dfdb; display:flex; align-items:center; justify-content:center; font-size:15px; }

  .addr-new-form  { border:1.5px solid #b2dfdb; border-radius:10px; padding:16px; background:#f9fefe; animation:fadeUp 0.2s ease; }
  .addr-new-title { font-size:13px; font-weight:700; color:#00796b; margin-bottom:14px; }
  .cf label { display:block; margin-bottom:4px; font-size:10.5px; font-weight:700; color:#78909c; text-transform:uppercase; letter-spacing:.07em; }
  .cf input, .cf textarea { width:100%; padding:9px 12px; border:1.5px solid #dde4e3; border-radius:7px; font-size:13.5px; color:#1a2e2c; background:#fff; outline:none; transition:border-color .15s, box-shadow .15s; box-sizing:border-box; font-family:inherit; }
  .cf input:focus, .cf textarea:focus { border-color:#009688; box-shadow:0 0 0 3px rgba(0,150,136,.1); }
  .cf input::placeholder { color:#c5d0cf; }
  .cf input.has-err { border-color:#e53935; }
  .cf .err { font-size:11px; color:#e53935; margin-top:3px; }
  .addr-form-btns { display:flex; gap:8px; margin-top:14px; }
  .btn-addr-save { padding:9px 18px; background:#009688; color:#fff; border:none; border-radius:7px; font-size:13px; font-weight:700; cursor:pointer; display:flex; align-items:center; gap:6px; transition:background .15s; }
  .btn-addr-save:hover:not(:disabled) { background:#00796b; }
  .btn-addr-save:disabled { opacity:.5; cursor:not-allowed; }
  .btn-addr-cancel { padding:9px 14px; background:#fff; color:#78909c; border:1.5px solid #dde4e3; border-radius:7px; font-size:13px; font-weight:600; cursor:pointer; transition:all .15s; }
  .btn-addr-cancel:hover { border-color:#90a4ae; }
  .chk-row { display:flex; align-items:center; gap:7px; font-size:12.5px; color:#455a64; cursor:pointer; user-select:none; }
  .chk-row input { width:14px; height:14px; accent-color:#009688; cursor:pointer; }

  /* ── Tax breakdown panel ── */
  .tax-panel {
    background:#fffde7; border:1px solid #ffe082; border-radius:10px;
    padding:12px 14px; margin-bottom:12px; animation:taxSlide 0.25s ease;
  }
  .tax-panel-title {
    font-size:11.5px; font-weight:800; color:#e65100; text-transform:uppercase;
    letter-spacing:.06em; margin-bottom:8px; display:flex; align-items:center; gap:5px;
  }
  .tax-item-row {
    display:flex; justify-content:space-between; align-items:center;
    font-size:12.5px; padding:4px 0; border-bottom:1px dashed #ffe082;
  }
  .tax-item-row:last-child { border-bottom:none; padding-bottom:0; }
  .tax-item-name  { color:#5d4037; font-weight:500; flex:1; min-width:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; padding-right:8px; }
  .tax-item-pct   { color:#e65100; font-weight:700; font-size:11px; background:#fff3e0; padding:2px 7px; border-radius:12px; margin-right:8px; white-space:nowrap; }
  .tax-item-amt   { color:#bf360c; font-weight:700; white-space:nowrap; }
  .tax-exempt-row {
    display:flex; justify-content:space-between; align-items:center;
    font-size:12px; padding:4px 0; color:#78909c; border-bottom:1px dashed #e0e0e0;
  }
  .tax-exempt-row:last-child { border-bottom:none; }
  .tax-total-row  {
    display:flex; justify-content:space-between; align-items:center;
    font-size:13.5px; font-weight:800; padding-top:8px; margin-top:6px;
    border-top:1.5px solid #ffca28; color:#bf360c;
  }
  .tax-loading-row {
    display:flex; align-items:center; gap:8px;
    font-size:12.5px; color:#90a4ae; padding:8px 0;
  }
  .tax-state-note {
    font-size:11px; color:#78909c; margin-top:6px; display:flex; align-items:center; gap:4px;
  }

  /* Summary card */
  .sum-card {
    background:#fff; border-radius:16px; overflow:hidden;
    box-shadow:0 4px 24px rgba(0,150,136,.13), 0 1px 4px rgba(0,0,0,.07);
    border:1.5px solid #b2dfdb; position:sticky; top:16px;
  }
  .sum-head {
    background:linear-gradient(135deg,#00695c 0%,#009688 60%,#26a69a 100%);
    padding:20px 22px; color:#fff; position:relative; overflow:hidden;
  }
  .sum-head::after {
    content:''; position:absolute; right:-20px; top:-20px;
    width:100px; height:100px; border-radius:50%;
    background:rgba(255,255,255,.07); pointer-events:none;
  }
  .sum-head-title { font-size:16px; font-weight:800; margin:0; letter-spacing:-.2px; }
  .sum-head-sub   { font-size:12px; opacity:.7; margin-top:3px; }
  .sum-body { padding:18px 20px; }
  .sum-row  { display:flex; justify-content:space-between; align-items:center; font-size:13.5px; padding:7px 0; }
  .sum-lbl  { color:#78909c; }
  .sum-val  { color:#1a2e2c; font-weight:600; }
  .sum-free { color:#009688; font-weight:600; font-size:12px; }
  .sum-tax  { color:#e65100; font-weight:700; }
  .sum-divider   { height:1px; background:linear-gradient(90deg,#e0f2f1,#b2dfdb,#e0f2f1); margin:10px 0; }
  .sum-total-row { display:flex; justify-content:space-between; align-items:center; padding:8px 0 14px; }
  .sum-total-lbl { font-size:14px; font-weight:700; color:#1a2e2c; }
  .sum-total-val { font-size:24px; font-weight:900; color:#009688; letter-spacing:-.5px; }
  .sum-addr-box {
    padding:10px 13px; border-radius:10px;
    background:linear-gradient(135deg,#f0faf9,#e8f5e9);
    border:1px solid #c8e6e3; display:flex; gap:10px;
    align-items:flex-start; margin-bottom:10px; font-size:12px;
  }
  .sum-addr-box-icon { font-size:16px; flex-shrink:0; margin-top:1px; }
  .sum-addr-box-tag  { font-size:10px; font-weight:800; color:#009688; text-transform:uppercase; letter-spacing:.08em; margin-bottom:2px; }
  .sum-addr-box-name { font-size:13px; font-weight:700; color:#1a2e2c; margin-bottom:2px; }
  .sum-addr-box-text { color:#607d8b; line-height:1.5; }
  .sum-warn { padding:9px 12px; border-radius:9px; font-size:12px; margin-bottom:10px; display:flex; align-items:center; gap:7px; }
  .sum-warn.yellow { background:#fffbeb; border:1px solid #fde68a; color:#92400e; }
  .sum-warn.red    { background:#ffebee; border:1px solid #ef9a9a; color:#b71c1c; }

  .btn-place {
    width:100%; padding:15px; border:none; border-radius:12px; font-size:15px; font-weight:800;
    cursor:pointer; display:flex; align-items:center; justify-content:center; gap:8px;
    transition:all .25s; letter-spacing:.01em;
    background:linear-gradient(135deg,#00897b,#009688,#26a69a);
    color:#fff; box-shadow:0 4px 15px rgba(0,150,136,.3);
  }
  .btn-place:hover:not(:disabled) {
    background:linear-gradient(135deg,#00695c,#00897b,#009688);
    transform:translateY(-2px); box-shadow:0 8px 25px rgba(0,150,136,.38);
  }
  .btn-place:disabled { opacity:.45; cursor:not-allowed; transform:none; box-shadow:none; }
  .btn-back { width:100%; margin-top:8px; padding:10px; background:transparent; color:#009688; border:1.5px solid #b2dfdb; border-radius:10px; font-size:13px; font-weight:600; cursor:pointer; transition:all .15s; }
  .btn-back:hover { background:#e0f2f1; border-color:#009688; }
  .secure-row { display:flex; align-items:center; justify-content:center; gap:5px; font-size:11px; color:#90a4ae; margin-top:12px; padding-top:12px; border-top:1px solid #f0f4f3; }

  .btn-spinner  { width:15px; height:15px; border-radius:50%; border:2px solid rgba(255,255,255,.35); border-top-color:#fff; animation:spin .7s linear infinite; }
  .addr-spinner { width:16px; height:16px; border-radius:50%; border:2px solid #b2dfdb; border-top-color:#009688; animation:spin .7s linear infinite; }
  .addr-loading-row  { display:flex; align-items:center; gap:10px; padding:14px; color:#90a4ae; font-size:13px; }
  .item-count-badge  { background:#e0f2f1; color:#00796b; font-size:11.5px; font-weight:600; padding:3px 10px; border-radius:20px; margin-left:auto; }

  .oos-banner { background:#ffebee; border:1px solid #ef9a9a; border-radius:10px; padding:14px 16px; display:flex; gap:12px; align-items:flex-start; font-size:13px; color:#b71c1c; margin-bottom:14px; }

  /* ── Inline tax per item ── */
  .oi-tax-row {
    display:flex; align-items:center; justify-content:space-between;
    margin-top:5px; padding:5px 10px;
    background:#fffde7; border:1px solid #ffe082; border-radius:7px;
    font-size:12px; animation:taxSlide 0.2s ease;
  }
  .oi-tax-row-left  { display:flex; align-items:center; gap:6px; color:#e65100; font-weight:600; }
  .oi-tax-row-right { color:#bf360c; font-weight:800; font-size:12.5px; }

  .oi-tax-exempt-row {
    display:flex; align-items:center; gap:6px;
    margin-top:5px; padding:4px 10px;
    background:#f1f8e9; border:1px solid #c5e1a5; border-radius:7px;
    font-size:11.5px; color:#558b2f; font-weight:600;
  }

  .oi-tax-loading-row {
    display:flex; align-items:center; gap:6px;
    margin-top:5px; padding:4px 10px;
    background:#f5f5f5; border:1px solid #e0e0e0; border-radius:7px;
    font-size:11.5px; color:#90a4ae;
  }

  /* ── Tax footer inside order items card ── */
  .oi-tax-footer {
    display:flex; justify-content:space-between; align-items:center;
    margin:10px 0 4px; padding:10px 14px;
    background:linear-gradient(135deg,#fff8e1,#fffde7);
    border:1.5px solid #ffe082; border-radius:9px;
    animation:taxSlide 0.25s ease;
  }
  .oi-tax-footer-left  { font-size:13px; font-weight:700; color:#e65100; display:flex; align-items:center; gap:7px; }
  .oi-tax-footer-right { font-size:16px; font-weight:800; color:#bf360c; }
  .oi-tax-footer-note  { font-size:11px; color:#78909c; margin-top:3px; }

  .oi-tax-loading-footer {
    display:flex; align-items:center; gap:8px;
    margin:8px 0 4px; padding:9px 14px;
    background:#f9f9f9; border:1px solid #eeeeee; border-radius:9px;
    font-size:12px; color:#90a4ae;
  }

  .remarks-area { width:100%; padding:10px 13px; border:1.5px solid #dde4e3; border-radius:8px; font-size:13.5px; color:#1a2e2c; background:#fff; resize:vertical; min-height:72px; font-family:inherit; outline:none; box-sizing:border-box; transition:border-color .15s; }
  .remarks-area:focus { border-color:#009688; box-shadow:0 0 0 3px rgba(0,150,136,.1); }
  .remarks-area::placeholder { color:#c5d0cf; }

  .same-toggle { display:flex; align-items:center; gap:7px; margin-left:auto; cursor:pointer; background:#f1f5f9; border:1px solid #dde4e3; border-radius:20px; padding:4px 10px; transition:all .15s; }
  .same-toggle:hover   { background:#e0f2f1; border-color:#b2dfdb; }
  .same-toggle.active  { background:#e0f2f1; border-color:#b2dfdb; }
  .same-toggle input   { accent-color:#009688; cursor:pointer; }
  .same-toggle span    { font-size:12px; font-weight:600; color:#455a64; white-space:nowrap; }
  .same-toggle.active span { color:#00796b; }
`;

/* ═══════════════════════════════ UTILS ═══════════════════════════════ */
const parsePrice = v => {
  if (v == null || v === '' || v === 'N/A') return null;
  const n = parseFloat(typeof v === 'string' ? v.replace(/[$,]/g, '') : v);
  return !isNaN(n) && n > 0 ? n : null;
};
const isOutOfStock = i =>
  i.stock === 0 || i.stockQuantity === 0 || i.inStock === false ||
  i.stockStatus === 'out_of_stock' || i.availableQuantity === 0;

/* ── Extract tax percentage from various API response shapes ── */
const extractTaxPct = (res) => {
  if (res === null || res === undefined) return null;

  // ✅ API returns a plain number: response body is just "5"
  if (typeof res === 'number') {
    return res > 0 ? res : null;
  }
  // Also handle string like "5" or "5.0"
  if (typeof res === 'string') {
    const n = parseFloat(res);
    return !isNaN(n) && n > 0 ? n : null;
  }

  // Object response: try all known field names
  const raw =
    res.percentage      ??   // confirmed API field name
    res.taxPercentage   ??
    res.TaxPercentage   ??
    res.tax_percentage  ??
    res.Percentage      ??
    res.rate            ??
    res.Rate            ??
    res.taxRate         ??
    res.TaxRate         ??
    null;
  const n = parseFloat(raw);
  return !isNaN(n) && n > 0 ? n : null;
};

const extractTaxName = (res) => {
  if (!res) return '';
  return (
    res.taxName     ||
    res.TaxName     ||
    res.tax_name    ||
    res.name        ||
    res.Name        ||
    res.taxType     ||
    res.TaxType     ||
    res.stateName   ||   // API returns stateName — use as fallback label
    res.StateName   ||
    ''
  );
};

/* ─── State name normalization ───────────────────────────────────────────────
 * The DB can have typos ("Gujrat" vs "Gujarat"). This generates candidate
 * spellings so we try each one until the API returns a valid tax rate.
 */
const TYPO_MAP = {
  'gujarat':     ['Gujrat',      'Gujarat',     'GUJARAT'],
  'gujrat':      ['Gujarat',     'Gujrat'],
  'maharashtra': ['Maharashtra', 'Maharastra',  'maharashtra'],
  'rajasthan':   ['Rajasthan',   'Rajsthan'],
  'karnataka':   ['Karnataka',   'Karnatka'],
  'tamilnadu':   ['Tamil Nadu',  'TamilNadu',   'Tamilnadu'],
  'tamil nadu':  ['TamilNadu',   'Tamil Nadu',  'Tamilnadu'],
  'uttar pradesh': ['UttarPradesh', 'Uttar Pradesh'],
  'west bengal': ['WestBengal',  'West Bengal'],
};

const normalizeStateName = (rawState) => {
  if (!rawState) return [];
  const s = rawState.trim();
  const lower = s.toLowerCase();
  const candidates = new Set();

  // If there's a known typo/alias mapping, those come FIRST (highest priority)
  // because they are the confirmed spellings the API actually accepts.
  const typos = TYPO_MAP[lower];
  if (typos) typos.forEach(v => candidates.add(v));

  // Then fallback candidates in order: lowercase, exact, TitleCase, UPPER
  candidates.add(lower);
  candidates.add(s);
  candidates.add(s.charAt(0).toUpperCase() + s.slice(1).toLowerCase());
  candidates.add(s.replace(/\b\w/g, c => c.toUpperCase()));
  candidates.add(s.toUpperCase());

  return [...candidates];
};

/**
 * Try product-specific tax across all state name variants.
 * Returns { pct, name } or { pct: null, name: '' }.
 */
const fetchProductTaxWithFallback = async (productId, rawStateName) => {
  const candidates = normalizeStateName(rawStateName);

  for (const stateName of candidates) {
    try {
      const res = await apiService.getProductTax(productId, stateName);
      const pct = extractTaxPct(res);
      if (pct !== null) {
        console.log(`✅ Tax hit: productId=${productId} state="${stateName}" pct=${pct}%`);
        return { pct, name: extractTaxName(res) || `${pct}% Tax` };
      }
    } catch { /* 404 or network — try next candidate */ }
  }

  console.log(`ℹ️ No tax found: productId=${productId} rawState="${rawStateName}" tried=[${candidates.join(', ')}]`);
  return { pct: null, name: '' };
};

/* ═══════════════════════════════ CONFIRM MODAL ═══════════════════════════════ */
function ConfirmModal({ addr, onConfirm, onCancel, deleting }) {
  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget && !deleting) onCancel();
  };
  return (
    <div className="confirm-overlay" onClick={handleBackdrop}>
      <div className="confirm-modal">
        <div className="confirm-modal-icon">🗑️</div>
        <div className="confirm-modal-title">Delete Address</div>
        <div className="confirm-modal-msg">
          Are you sure you want to remove{' '}
          <strong>{addr?.fullName || 'this address'}</strong> from your saved
          addresses? This action cannot be undone.
        </div>
        <div className="confirm-modal-btns">
          <button className="btn-confirm-cancel" onClick={onCancel} disabled={deleting}>
            Cancel
          </button>
          <button className="btn-confirm-delete" onClick={onConfirm} disabled={deleting}>
            {deleting
              ? <><div className="addr-spinner" style={{ border: '2px solid rgba(255,255,255,.3)', borderTopColor: '#fff' }} /> Deleting…</>
              : '🗑️ Yes, Delete'
            }
          </button>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════ ADDR ROW ═══════════════════════════════ */
function AddrRow({ addr, selected, onSelect, onDelete }) {
  const id = addr.id || addr.addressId;
  const city = [addr.city, addr.state, addr.pincode].filter(Boolean).join(', ');
  const line = [addr.addressLine1, addr.addressLine2, addr.landmark, city, addr.country].filter(Boolean).join(', ');
  return (
    <div className={`addr-row${selected ? ' selected' : ''}`} onClick={() => onSelect(id)}>
      <div className="addr-radio"><div className="addr-radio-dot" /></div>
      <div className="addr-info">
        <div className="addr-name-row">
          <span className="addr-fullname">{addr.fullName || 'Address'}</span>
          {addr.mobileNo && <span className="addr-phone">· {addr.mobileNo}</span>}
          {addr.isDefault  && <span className="addr-badge badge-default">Default</span>}
          {addr.isBilling  && <span className="addr-badge badge-billing">Billing</span>}
          {addr.isShipping && <span className="addr-badge badge-shipping">Shipping</span>}
        </div>
        {line && <div className="addr-line">{line}</div>}
        {addr.email && <div className="addr-email">{addr.email}</div>}
      </div>
      {onDelete && (
        <button
          className="addr-delete-btn"
          title="Delete this address"
          onClick={e => { e.stopPropagation(); onDelete(addr); }}
        >
          🗑️
        </button>
      )}
    </div>
  );
}

/* ═══════════════════════════════ FIELD RENDERER ═══════════════════════════════ */
function renderField({ label, k, placeholder, req, type = 'text', value, onChange, error }) {
  return (
    <div className="cf" style={{ marginBottom: 0 }}>
      <label>{label}{req && <span style={{ color: '#e53935' }}> *</span>}</label>
      <input
        type={type} placeholder={placeholder} value={value}
        onChange={e => onChange(k, e.target.value)}
        className={error ? 'has-err' : ''}
      />
      {error && <div className="err">{error}</div>}
    </div>
  );
}

/* ═══════════════════════════════ NEW ADDRESS FORM ═══════════════════════════════ */
const BLANK = {
  fullName: '', mobileNo: '', alternateMobileNo: '', email: '',
  addressLine1: '', addressLine2: '', landmark: '',
  city: '', state: '', country: 'USA', pincode: '',
  isDefault: false, isBilling: true, isShipping: true,
};

function NewAddressForm({ onSave, onCancel, saving }) {
  const [f, setF] = useState(BLANK);
  const [err, setErr] = useState({});

  const set = (k, v) => {
    if (k === 'country') return;
    setF(p => ({ ...p, [k]: v }));
    setErr(p => ({ ...p, [k]: '' }));
  };

  const validate = () => {
    const e = {};
    if (!f.fullName.trim()) e.fullName = 'Required';
    if (!f.mobileNo.trim()) {
      e.mobileNo = 'Required';
    } else {
      const r = validatePhoneNumber(f.mobileNo.trim());
      if (!r.valid) e.mobileNo = r.message;
    }
    if (f.alternateMobileNo.trim()) {
      const r = validatePhoneNumber(f.alternateMobileNo.trim());
      if (!r.valid) e.alternateMobileNo = r.message;
    }
    if (!f.addressLine1.trim()) e.addressLine1 = 'Required';
    if (!f.city.trim()) e.city = 'Required';
    if (!f.state.trim()) e.state = 'Required';
    if (!f.pincode.trim()) e.pincode = 'Required';
    setErr(e);
    return !Object.keys(e).length;
  };

  const rf = (label, k, placeholder, req, type) =>
    renderField({ label, k, placeholder, req, type, value: f[k], onChange: set, error: err[k] });

  return (
    <div className="addr-new-form">
      <div className="addr-new-title">📍 Add New Address</div>
      <div className="row g-2">
        <div className="col-md-6">{rf('Full Name', 'fullName', 'John Doe', true)}</div>
        <div className="col-md-6 cf">
          <label>Mobile <span style={{ color: '#e53935' }}>*</span></label>
          <SmartPhoneInput
            value={f.mobileNo}
            onChange={e => set('mobileNo', e.target.value)}
            onBlur={() => {
              if (f.mobileNo.trim()) {
                const r = validatePhoneNumber(f.mobileNo.trim());
                setErr(p => ({ ...p, mobileNo: r.valid ? '' : r.message }));
              }
            }}
            error={err.mobileNo}
            name="mobileNo"
          />
          {err.mobileNo && (
            <div className="err" style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 4 }}>
              ⚠️ {err.mobileNo}
            </div>
          )}
        </div>
        <div className="col-md-6 cf">
          <label>Alt. Mobile</label>
          <SmartPhoneInput
            value={f.alternateMobileNo}
            onChange={e => set('alternateMobileNo', e.target.value)}
            onBlur={() => {
              if (f.alternateMobileNo.trim()) {
                const r = validatePhoneNumber(f.alternateMobileNo.trim());
                setErr(p => ({ ...p, alternateMobileNo: r.valid ? '' : r.message }));
              }
            }}
            error={err.alternateMobileNo}
            name="alternateMobileNo"
          />
          {err.alternateMobileNo && (
            <div className="err" style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 4 }}>
              ⚠️ {err.alternateMobileNo}
            </div>
          )}
        </div>
        <div className="col-md-6">{rf('Email', 'email', 'john@email.com', false, 'email')}</div>
        <div className="col-12">  {rf('Address Line 1', 'addressLine1', 'House no., Street', true)}</div>
        <div className="col-12">  {rf('Address Line 2', 'addressLine2', 'Area, Colony (optional)')}</div>
        <div className="col-md-6">{rf('Landmark', 'landmark', 'Near landmark')}</div>
        <div className="col-md-6">{rf('City', 'city', 'City', true)}</div>
        <div className="col-md-4">{rf('State', 'state', 'State', true)}</div>
        <div className="col-md-4">{rf('Pincode', 'pincode', '380001', true)}</div>
        <div className="col-md-4">
          <div className="cf">
            <label>Country</label>
            <input type="text" value="USA" readOnly />
          </div>
        </div>
        <div className="col-12">
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, marginTop: 6 }}>
            {[['isDefault', 'Set as default'], ['isBilling', 'Billing'], ['isShipping', 'Shipping']].map(([key, lbl]) => (
              <label key={key} className="chk-row">
                <input type="checkbox" checked={f[key]} onChange={e => set(key, e.target.checked)} />
                {lbl}
              </label>
            ))}
          </div>
        </div>
      </div>
      <div className="addr-form-btns">
        <button className="btn-addr-save" onClick={() => validate() && onSave(f)} disabled={saving}>
          {saving
            ? <><div className="addr-spinner" style={{ border: '2px solid rgba(255,255,255,.3)', borderTopColor: '#fff' }} />Saving…</>
            : '💾 Save Address'
          }
        </button>
        <button className="btn-addr-cancel" onClick={onCancel} disabled={saving}>Cancel</button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════ ADDRESS SECTION ═══════════════════════════════ */
function AddressSection({ selectedId, onSelect, onAddressesLoaded }) {
  const [addresses, setAddresses]   = useState([]);
  const [loading, setLoading]       = useState(true);
  const [showForm, setShowForm]     = useState(false);
  const [saving, setSaving]         = useState(false);
  const [confirmAddr, setConfirmAddr] = useState(null);
  const [deleting, setDeleting]     = useState(false);

  const userId = localStorage.getItem('userId');

  const load = async () => {
    if (!userId) { setLoading(false); return; }
    try {
      const data = await apiService.getUserAddresses(userId);
      const list = Array.isArray(data) ? data : [];
      setAddresses(list);
      onAddressesLoaded?.(list);
      if (list.length && !selectedId) {
        const def = list.find(a => a.isDefault) || list[0];
        onSelect(def.id || def.addressId);
      }
    } catch { setAddresses([]); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleSelect = id => { onSelect(id); setShowForm(false); };

  const handleSave = async formData => {
    setSaving(true);
    try {
      const saved = await apiService.createAddress(formData);
      const data  = await apiService.getUserAddresses(userId);
      const list  = Array.isArray(data) ? data : [];
      setAddresses(list);
      onAddressesLoaded?.(list);
      setShowForm(false);
      const newId = saved?.id || saved?.addressId;
      if (newId) onSelect(newId);
    } catch { alert('Failed to save address. Please try again.'); }
    finally { setSaving(false); }
  };

  const handleConfirmDelete = async () => {
    if (!confirmAddr || deleting) return;
    setDeleting(true);
    try {
      const id = confirmAddr.id || confirmAddr.addressId;
      await apiService.deleteAddress(id);
      const data = await apiService.getUserAddresses(userId);
      const list = Array.isArray(data) ? data : [];
      setAddresses(list);
      onAddressesLoaded?.(list);
      if (selectedId === id) {
        const next = list[0];
        onSelect(next ? (next.id || next.addressId) : null);
      }
    } catch { alert('Failed to delete address. Please try again.'); }
    finally { setDeleting(false); setConfirmAddr(null); }
  };

  if (loading) return (
    <div className="addr-loading-row">
      <div className="addr-spinner" />Loading addresses…
    </div>
  );

  return (
    <>
      {confirmAddr && (
        <ConfirmModal
          addr={confirmAddr}
          onConfirm={handleConfirmDelete}
          onCancel={() => { if (!deleting) setConfirmAddr(null); }}
          deleting={deleting}
        />
      )}
      <div className="addr-list">
        {addresses.length === 0 && !showForm && (
          <div style={{ fontSize: 13, color: '#90a4ae', textAlign: 'center', padding: '10px 0' }}>
            No saved addresses yet. Add one below.
          </div>
        )}
        {addresses.map(a => (
          <AddrRow
            key={a.id || a.addressId}
            addr={a}
            selected={selectedId === (a.id || a.addressId)}
            onSelect={handleSelect}
            onDelete={setConfirmAddr}
          />
        ))}
        {!showForm && (
          <div className="addr-add-row" onClick={() => setShowForm(true)}>
            <div className="addr-add-icon">+</div>
            Add a new address
          </div>
        )}
        {showForm && (
          <NewAddressForm onSave={handleSave} onCancel={() => setShowForm(false)} saving={saving} />
        )}
      </div>
    </>
  );
}

/* ═══════════════════════════════ ADDR PREVIEW ═══════════════════════════════ */
function AddrPreview({ icon, tag, addr }) {
  if (!addr) return null;
  const line = [addr.addressLine1, addr.city, addr.state, addr.pincode].filter(Boolean).join(', ');
  return (
    <div className="sum-addr-box">
      <span className="sum-addr-box-icon">{icon}</span>
      <div>
        <div className="sum-addr-box-tag">{tag}</div>
        <div className="sum-addr-box-name">{addr.fullName}</div>
        <div className="sum-addr-box-text">{line}</div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════ TAX BREAKDOWN PANEL ═══════════════════════════════
 * taxMap: { [productId]: { taxPct, taxName, taxAmt, isTaxable, productName } }
 * Shows taxable items with % and $, exempt items greyed out, and a total row.
 */
function TaxBreakdownPanel({ taxMap, stateName, loading }) {
  if (!stateName) return null;

  const entries  = Object.values(taxMap);
  const taxable  = entries.filter(e => e.isTaxable);
  const exempt   = entries.filter(e => !e.isTaxable);
  const totalTax = taxable.reduce((s, e) => s + (e.taxAmt || 0), 0);

  return (
    <div className="tax-panel">
      <div className="tax-panel-title">
        🧾 Tax Breakdown
        {loading && <span style={{ fontWeight: 400, color: '#b0bec5', marginLeft: 6, fontSize: 11 }}>recalculating…</span>}
      </div>

      {loading && entries.length === 0 && (
        <div className="tax-loading-row">
          <div className="addr-spinner" /> Fetching tax rates for {stateName}…
        </div>
      )}

      {/* Taxable products */}
      {taxable.map((e, i) => (
        <div className="tax-item-row" key={i}>
          <span className="tax-item-name" title={e.productName}>{e.productName}</span>
          <span className="tax-item-pct">{e.taxPct}%{e.taxName ? ` ${e.taxName}` : ''}</span>
          <span className="tax-item-amt">+${e.taxAmt.toFixed(2)}</span>
        </div>
      ))}

      {/* Exempt products */}
      {exempt.map((e, i) => (
        <div className="tax-exempt-row" key={i}>
          <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingRight: 8 }} title={e.productName}>
            {e.productName}
          </span>
          <span style={{ fontSize: 11, background: '#f1f8e9', color: '#558b2f', padding: '2px 7px', borderRadius: 12, fontWeight: 700 }}>Tax Exempt</span>
          <span style={{ marginLeft: 8, color: '#aaa', fontWeight: 700 }}>$0.00</span>
        </div>
      ))}

      {/* Total tax */}
      {!loading && entries.length > 0 && (
        <div className="tax-total-row">
          <span>Total Tax</span>
          <span>${totalTax.toFixed(2)}</span>
        </div>
      )}

      <div className="tax-state-note">
        📍 Rates calculated for state: <strong style={{ marginLeft: 3 }}>{stateName}</strong>
      </div>
    </div>
  );
}

/* ═══════════════════════════════ MAIN CHECKOUT ═══════════════════════════════ */
export default function Checkout({ cartItems = [], onNavigate, onOrderComplete, isLoggedIn }) {
  const [remarks, setRemarks]         = useState('');
  const [shippingId, setShippingId]   = useState(null);
  const [billingId, setBillingId]     = useState(null);
  const [sameAddress, setSameAddress] = useState(false);
  const [placing, setPlacing]         = useState(false);
  const [allAddrs, setAllAddrs]       = useState([]);

  // ── Tax state ──────────────────────────────────────────────────────────────
  // taxMap: { [productId]: { taxPct, taxName, taxAmt, isTaxable, productName } }
  const [taxMap, setTaxMap]         = useState({});
  const [taxLoading, setTaxLoading] = useState(false);
  const taxFetchRef = useRef(null); // tracks abort between fetches

  useEffect(() => {
    if (isLoggedIn === false) onNavigate?.('login');
  }, [isLoggedIn]);

  /* ── Fetch taxes whenever shipping address (= state) or cart changes ── */
  useEffect(() => {
    const shippingAddr = allAddrs.find(a => (a.id || a.addressId) === shippingId);
    const stateName    = shippingAddr?.state?.trim();

    if (!stateName || cartItems.length === 0) {
      setTaxMap({});
      return;
    }

    // Cancel any in-flight fetch
    let cancelled = false;
    taxFetchRef.current = () => { cancelled = true; };

    const fetchTaxes = async () => {
      setTaxLoading(true);
      const result = {};

      for (const item of cartItems) {
        if (cancelled) break;

        // Resolve productId from whatever field Layout.jsx puts it in.
        // Most likely item.productId, but fallback to other common names.
        const productId =
          item.productId     ||
          item.apiProductId  ||
          item.ProductId     ||
          item.product_id    ||
          (item.product && (item.product.id || item.product.productId)) ||
          null;

        // Skip this item entirely if no valid productId — prevents ?productId=undefined
        if (!productId) {
          console.warn(`⚠️ Skipping tax for "${item.name}" — productId missing. Add productId to your cartItems mapping in Layout.jsx`);
          result[item.id || item.cartItemId || item.name] = {
            isTaxable: false, taxPct: 0, taxName: '', taxAmt: 0,
            productName: item.name || 'Unknown product',
            missingProductId: true,
          };
          continue;
        }
        const price     = parsePrice(item.price) ?? 0;
        const qty       = item.quantity || 1;
        const lineTotal = price * qty;

        // fetchProductTaxWithFallback tries "Gujarat", "Gujrat", "gujarat",
        // "GUJARAT", etc. until one returns a valid percentage from the API.
        const { pct, name } = await fetchProductTaxWithFallback(productId, stateName);

        // Store under productId AND all fallback keys so render always finds it
        const fallbackKey = item.id || item.cartItemId || item.name;
        const entry = pct !== null ? {
          isTaxable:   true,
          taxPct:      pct,
          taxName:     name,
          taxAmt:      parseFloat(((lineTotal * pct) / 100).toFixed(2)),
          productName: item.name || `Product #${productId}`,
        } : {
          isTaxable:   false,
          taxPct:      0,
          taxName:     '',
          taxAmt:      0,
          productName: item.name || `Product #${productId}`,
        };
        result[productId] = entry;
        if (fallbackKey && fallbackKey !== productId) result[fallbackKey] = entry;
      }

      if (!cancelled) {
        setTaxMap(result);
        setTaxLoading(false);
      }
    };

    fetchTaxes();
    return () => { cancelled = true; };
  }, [shippingId, cartItems, allAddrs]);

  /* ── Derived totals ── */
  const hasOos   = cartItems.some(isOutOfStock);
  const oosNames = cartItems.filter(isOutOfStock).map(i => i.name).join(', ');

  const subtotal = cartItems.reduce((s, i) => {
    const p = parsePrice(i.price);
    return p ? s + p * i.quantity : s;
  }, 0);

  const totalTax = Object.values(taxMap)
    .filter(e => e.isTaxable)
    .reduce((s, e) => s + (e.taxAmt || 0), 0);

  const grandTotal = subtotal + totalTax;

  const effectiveBillingId = sameAddress ? shippingId : billingId;
  const canPlace = cartItems.length > 0 && !hasOos && !!shippingId && !!effectiveBillingId;

  const selShipping = allAddrs.find(a => (a.id || a.addressId) === shippingId);
  const selBilling  = allAddrs.find(a => (a.id || a.addressId) === effectiveBillingId);
  const shippingState = selShipping?.state?.trim() || '';

  const mergeAddresses = (list) => {
    setAllAddrs(prev => {
      const existingIds = new Set(prev.map(a => a.id || a.addressId));
      const newOnes = list.filter(a => !existingIds.has(a.id || a.addressId));
      return newOnes.length ? [...prev, ...newOnes] : prev;
    });
  };

  /* ── Place order ── */
  const handlePlace = async () => {
    if (!shippingId)        { alert('Please select a shipping address.'); return; }
    if (!effectiveBillingId){ alert('Please select a billing address.');  return; }
    if (!cartItems.length)  { alert('Your cart is empty.');               return; }
    if (hasOos)             { alert(`Remove out-of-stock items first: ${oosNames}`); return; }

    const userId = localStorage.getItem('userId');
    const token  = localStorage.getItem('authToken');
    const cartId = localStorage.getItem('cartId');

    if (!userId || !token) {
      alert('Session expired. Please login again.');
      onNavigate?.('login');
      return;
    }

    setPlacing(true);
    try {
      const orderPayload = {
        userId:            parseInt(userId),
        subTotal:          subtotal,
        taxAmount:         parseFloat(totalTax.toFixed(2)),  // ← real tax from API
        shippingAmount:    0,
        discountAmount:    0,
        billingAddressId:  parseInt(effectiveBillingId) || 0,
        shippingAddressId: parseInt(shippingId) || 0,
        placeholder1: 'string',
        placeholder2: 'string',
        placeholder3: 'string',
        placeholder4: 'string',
        paymentMethod: 0,
        remarks: remarks.trim() || 'string',
      };

      const res     = await apiService.createOrder(orderPayload);
      const orderId = res?.id || res?.orderId || res?.data?.id || (typeof res === 'number' ? res : null);
      if (!orderId) throw new Error('No order ID returned from server');

      for (const item of cartItems) {
        // Resolve the real productId — Layout.jsx may pass it under different field names
        const resolvedProductId =
          item.productId                                          ||
          item.apiProductId                                       ||
          item.ProductId                                          ||
          item.product_id                                         ||
          (item.product && (item.product.id || item.product.productId || item.product.ID)) ||
          null;

        if (!resolvedProductId) {
          console.error(`❌ createOrderItem skipped — no productId for "${item.name}". Check Layout.jsx cartItems mapping.`);
          continue; // skip rather than send productId: 0
        }

        await apiService.createOrderItem({
          orderId,
          productId:   resolvedProductId,
          productName: item.name || 'string',
          sku:         item.sku  || item.name || 'string',
          quantity:    item.quantity  || 1,
          unitPrice:   parsePrice(item.price) ?? 0,
        });
      }

      if (cartId) {
        await Promise.all(
          cartItems.filter(i => i.cartItemId).map(i => apiService.deleteCartItem(i.cartItemId))
        );
      }

      localStorage.removeItem('cartItems');
      localStorage.removeItem('cartId');
      onOrderComplete?.();
      alert(`✅ Order placed successfully!\nOrder ID: ${orderId}\nTax applied: $${totalTax.toFixed(2)}`);
      onNavigate?.('home');

    } catch (err) {
      console.error('❌ Order failed:', err);
      const msg = err?.response?.data?.message || err?.response?.data || err?.message || 'Unknown error';
      alert(`Failed to place order.\n\n${msg}\n\nPlease try again or contact support.`);
    } finally {
      setPlacing(false);
    }
  };

  const checkIcon = (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );

  return (
    <div className="co-page">
      <style>{styles}</style>

      {/* Header */}
      <section className="contact-header-section">
        <div className="container">
          <h1 className="contact-main-title">Checkout</h1>
          <p className="contact-subtitle">Review your order and complete your purchase.</p>
        </div>
      </section>

      <section style={{ padding: '28px 0 48px' }}>
        <div className="container">
          <div className="row g-4">

            {/* ══ LEFT COLUMN ══ */}
            <div className="col-lg-8">

              {hasOos && (
                <div className="oos-banner">
                  <span style={{ fontSize: 18 }}>🚫</span>
                  <div>
                    <strong style={{ display: 'block', marginBottom: 2 }}>Some items are out of stock</strong>
                    {oosNames}
                  </div>
                </div>
              )}

              {/* STEP 1 — Order Items */}
              <div className="co-card">
                <div className="co-card-head">
                  <div className={`step-badge${cartItems.length ? ' done' : ''}`}>
                    {cartItems.length ? checkIcon : '1'}
                  </div>
                  <span className="co-card-title">Order Items</span>
                  <span className="item-count-badge">
                    {cartItems.length} {cartItems.length === 1 ? 'item' : 'items'}
                  </span>
                </div>
                <div className="co-card-body" style={{ padding: '4px 20px 12px' }}>
                  {cartItems.length === 0 ? (
                    <div style={{ padding: '20px 0', textAlign: 'center', color: '#90a4ae', fontSize: 13 }}>
                      <div style={{ fontSize: 30, marginBottom: 8 }}>🛒</div>
                      Your cart is empty
                    </div>
                  ) : (
                    <>
                      {cartItems.map(item => {
                        const p         = parsePrice(item.price);
                        const oos       = isOutOfStock(item);
                        const lineTotal = p ? p * item.quantity : 0;

                        // Resolve the same key used when storing in taxMap
                        const taxKey =
                          item.productId    ||
                          item.apiProductId ||
                          item.ProductId    ||
                          item.product_id   ||
                          (item.product && (item.product.id || item.product.productId)) ||
                          item.id           ||
                          item.cartItemId   ||
                          item.name;
                        const taxEntry   = taxMap[taxKey];
                        const hasTaxInfo = !!taxEntry && !taxLoading;

                        return (
                          <div key={item.id || item.cartItemId} className="oi-row" style={oos ? { opacity: .5 } : {}}>
                            {/* Image */}
                            {item.image
                              ? <img src={item.image} alt={item.name} className="oi-img" onError={e => e.target.style.display = 'none'} />
                              : <div className="oi-fallback">🏥</div>
                            }

                            {/* Name + qty */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div className="oi-name">{item.name}</div>
                              <div className="oi-qty">Qty: {item.quantity}</div>

                              {/* Tax chip — inline under qty, only when shipping state is known */}
                              {!oos && shippingState && (
                                taxLoading && !hasTaxInfo ? (
                                  /* Loading state */
                                  <div style={{ display:'flex', alignItems:'center', gap:5, marginTop:5, fontSize:11, color:'#b0bec5' }}>
                                    <div className="addr-spinner" style={{ width:10, height:10, border:'2px solid #e0e0e0', borderTopColor:'#90a4ae' }} />
                                    Calculating tax…
                                  </div>
                                ) : hasTaxInfo && taxEntry.isTaxable ? (
                                  /* Taxable — show  "5% Tax · +$5.00" */
                                  <div style={{ display:'inline-flex', alignItems:'center', gap:6, marginTop:6,
                                    background:'#fff8e1', border:'1px solid #ffe082', borderRadius:20,
                                    padding:'3px 10px' }}>
                                    <span style={{ fontSize:11.5, fontWeight:800, color:'#e65100' }}>
                                      {taxEntry.taxPct}% Tax
                                    </span>
                                    <span style={{ width:1, height:11, background:'#ffcc02', display:'inline-block' }} />
                                    <span style={{ fontSize:11.5, fontWeight:800, color:'#bf360c' }}>
                                      +${taxEntry.taxAmt.toFixed(2)}
                                    </span>
                                  </div>
                                ) : hasTaxInfo && !taxEntry.isTaxable ? (
                                  /* Tax exempt */
                                  <div style={{ display:'inline-flex', alignItems:'center', gap:5, marginTop:6,
                                    background:'#f1f8e9', border:'1px solid #c5e1a5', borderRadius:20,
                                    padding:'3px 10px' }}>
                                    <span style={{ fontSize:11, color:'#2e7d32' }}>✅</span>
                                    <span style={{ fontSize:11.5, fontWeight:700, color:'#2e7d32' }}>Tax Exempt</span>
                                  </div>
                                ) : null
                              )}
                            </div>

                            {/* Price + tax amount on the right */}
                            <div style={{ textAlign:'right', flexShrink:0, minWidth:80 }}>
                              {oos ? (
                                <span className="oi-oos">Out of stock</span>
                              ) : p ? (
                                <>
                                  <div className="oi-price">${lineTotal.toFixed(2)}</div>
                                  {hasTaxInfo && taxEntry.isTaxable && (
                                    <div style={{ fontSize:11.5, color:'#e65100', fontWeight:700, marginTop:3 }}>
                                      +${taxEntry.taxAmt.toFixed(2)} tax
                                    </div>
                                  )}
                                </>
                              ) : (
                                <>
                                  <span className="oi-na">Price N/A</span>
                                  {hasTaxInfo && taxEntry.isTaxable && (
                                    <div style={{ fontSize:11, color:'#b0bec5', marginTop:3 }}>tax on checkout</div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        );
                      })}

                      {/* ── Tax footer — total tax for all items ── */}
                      {shippingState && (
                        taxLoading ? (
                          <div className="oi-tax-loading-footer">
                            <div className="addr-spinner" />
                            Calculating tax for {shippingState}…
                          </div>
                        ) : Object.keys(taxMap).length > 0 && (
                          <div className="oi-tax-footer">
                            <div>
                              <div className="oi-tax-footer-left">
                                🧾 Total Tax
                                <span style={{ fontSize: 11, fontWeight: 400, color: '#78909c' }}>
                                  ({shippingState})
                                </span>
                              </div>
                              <div className="oi-tax-footer-note">
                                {Object.values(taxMap).filter(e => e.isTaxable).length} of {cartItems.length} item(s) taxable
                              </div>
                            </div>
                            <div className="oi-tax-footer-right">
                              ${totalTax.toFixed(2)}
                            </div>
                          </div>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>

              {/* STEP 2 — Shipping Address */}
              <div className="co-card">
                <div className="co-card-head">
                  <div className={`step-badge${shippingId ? ' done' : ''}`}>
                    {shippingId ? checkIcon : '2'}
                  </div>
                  <span className="co-card-title">Shipping Address</span>
                  {!shippingId
                    ? <span style={{ marginLeft: 'auto', fontSize: 11.5, color: '#f59e0b', fontWeight: 600 }}>⚠ Required</span>
                    : <span style={{ marginLeft: 'auto', fontSize: 11.5, color: '#009688', fontWeight: 600 }}>✓ Selected</span>
                  }
                </div>
                <div className="co-card-body">
                  <AddressSection
                    selectedId={shippingId}
                    onSelect={setShippingId}
                    onAddressesLoaded={list => setAllAddrs(list)}
                  />
                </div>
              </div>

              {/* STEP 3 — Billing Address */}
              <div className="co-card">
                <div className="co-card-head">
                  <div className={`step-badge${effectiveBillingId ? ' done' : ''}`}>
                    {effectiveBillingId ? checkIcon : '3'}
                  </div>
                  <span className="co-card-title">Billing Address</span>
                  <label className={`same-toggle${sameAddress ? ' active' : ''}`} onClick={e => e.stopPropagation()}>
                    <input type="checkbox" checked={sameAddress} onChange={e => setSameAddress(e.target.checked)} />
                    <span>Same as shipping</span>
                  </label>
                </div>
                {sameAddress ? (
                  selShipping && (
                    <div className="co-card-body" style={{ paddingTop: 10, paddingBottom: 10 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#607d8b' }}>
                        <span>📋</span>
                        <span>
                          {selShipping.fullName} — {[selShipping.addressLine1, selShipping.city, selShipping.state].filter(Boolean).join(', ')}
                        </span>
                      </div>
                    </div>
                  )
                ) : (
                  <div className="co-card-body">
                    <AddressSection
                      selectedId={billingId}
                      onSelect={setBillingId}
                      onAddressesLoaded={mergeAddresses}
                    />
                  </div>
                )}
              </div>

              {/* STEP 4 — Order Notes */}
              <div className="co-card">
                <div className="co-card-head">
                  <div className="step-badge">4</div>
                  <span className="co-card-title">Order Notes</span>
                  <span style={{ marginLeft: 'auto', fontSize: 12, color: '#90a4ae' }}>Optional</span>
                </div>
                <div className="co-card-body">
                  <textarea
                    className="remarks-area"
                    placeholder="Delivery instructions, special requests…"
                    value={remarks}
                    onChange={e => setRemarks(e.target.value)}
                  />
                </div>
              </div>

            </div>

            {/* ══ RIGHT — Summary ══ */}
            <div className="col-lg-4">
              <div className="sum-card">
                <div className="sum-head">
                  <div className="sum-head-title">Order Summary</div>
                  <div className="sum-head-sub">Review before placing</div>
                </div>
                <div className="sum-body">

                  {/* ── Price rows ── */}
                  <div style={{ display:'flex', flexDirection:'column', gap:2, marginBottom:4 }}>

                    {/* Subtotal */}
                    <div className="sum-row">
                      <span className="sum-lbl">Subtotal <span style={{ color:'#b0bec5', fontSize:11 }}>({cartItems.length} item{cartItems.length !== 1 ? 's' : ''})</span></span>
                      <span className="sum-val">${subtotal.toFixed(2)}</span>
                    </div>

                    {/* Tax */}
                    <div className="sum-row">
                      <span className="sum-lbl" style={{ display:'flex', alignItems:'center', gap:5 }}>
                        Tax
                        {shippingState && (
                          <span style={{
                            fontSize:10, fontWeight:700, color:'#e65100',
                            background:'#fff3e0', border:'1px solid #ffe082',
                            padding:'1px 6px', borderRadius:10
                          }}>{shippingState}</span>
                        )}
                      </span>
                      {taxLoading ? (
                        <span style={{ display:'flex', alignItems:'center', gap:5, color:'#90a4ae', fontSize:12 }}>
                          <div className="addr-spinner" style={{ width:11, height:11 }} /> …
                        </span>
                      ) : shippingState && totalTax > 0 ? (
                        <span style={{ color:'#e65100', fontWeight:700, fontSize:14 }}>${totalTax.toFixed(2)}</span>
                      ) : (
                        <span style={{ color:'#b0bec5', fontSize:12 }}>
                          {shippingState ? '—' : 'after address'}
                        </span>
                      )}
                    </div>

                    {/* Shipping */}
                    <div className="sum-row">
                      <span className="sum-lbl">Shipping</span>
                      <span className="sum-free" style={{ fontSize:12 }}>Calculated at delivery</span>
                    </div>
                  </div>

                  {/* ── Divider ── */}
                  <div style={{ height:1, background:'linear-gradient(90deg,#e0f2f1,#b2dfdb,#e0f2f1)', margin:'12px 0' }} />

                  {/* ── Grand Total ── */}
                  <div style={{
                    display:'flex', justifyContent:'space-between', alignItems:'center',
                    padding:'10px 14px', borderRadius:10,
                    background:'linear-gradient(135deg,#e0f7fa,#e8f5e9)',
                    border:'1.5px solid #b2dfdb', marginBottom:14
                  }}>
                    <span style={{ fontSize:14, fontWeight:700, color:'#1a2e2c' }}>Total</span>
                    <span style={{ fontSize:24, fontWeight:900, color:'#009688', letterSpacing:'-0.5px' }}>
                      ${grandTotal.toFixed(2)}
                    </span>
                  </div>

                  {/* ── Address previews ── */}
                  {selShipping
                    ? <AddrPreview icon="🚚" tag="Ship To" addr={selShipping} />
                    : <div className="sum-warn yellow"><span>⚠️</span> Select a shipping address</div>
                  }

                  {!sameAddress && (
                    selBilling
                      ? <AddrPreview icon="🧾" tag="Bill To" addr={selBilling} />
                      : <div className="sum-warn yellow"><span>⚠️</span> Select a billing address</div>
                  )}

                  {hasOos && (
                    <div className="sum-warn red"><span>🚫</span> Remove out-of-stock items first</div>
                  )}

                  {/* ── Place Order button ── */}
                  <button
                    className="btn-place"
                    onClick={handlePlace}
                    disabled={placing || !canPlace || taxLoading}
                    style={{ marginTop:6 }}
                  >
                    {placing
                      ? <><div className="btn-spinner" />Processing…</>
                      : taxLoading
                        ? <><div className="btn-spinner" />Calculating tax…</>
                        : <><span style={{ fontSize:18 }}>🛒</span> Place Order</>
                    }
                  </button>

                  <button
                    className="btn-back"
                    onClick={() => onNavigate?.('products')}
                    disabled={placing}
                  >
                    ← Continue Shopping
                  </button>

                  <div className="secure-row">
                    🔒 Secured &amp; encrypted &nbsp;·&nbsp; SSL protected
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CTA Footer */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">
            <div className="row align-items-center">
              <div className="col-lg-8 mb-3 mb-lg-0">
                <h3 className="cta-title">Contact us today to learn more about our products.</h3>
              </div>
              <div className="col-lg-4 text-lg-end">
                <button
                  className="btn-cta"
                  onClick={() => { onNavigate?.('contact'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                >
                  Contact Us Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}